import wasteManagementClient from '../../services/wasteManagementClient';
import { wasteManagementUrls } from '../../appConfig';

export default class ReportsService {
  static getReports() {
    return wasteManagementClient
      .get(wasteManagementUrls.reports, {})
      .then((response) => {
        if (response.data && response.status === 200) {
          return response.data;
        } else {
          return [];
        }
      })
      .catch((error) => console.error(error));
  }

  static executeReport(reportId, from, to) {
    return wasteManagementClient
      .get(`${wasteManagementUrls.reports}/${reportId}`, {
        params: {
          from,
          to,
        },
      })
      .then((response) => {
        if (response.data && response.status === 200) {
          return response.data;
        } else {
          return [];
        }
      })
      .catch((error) => console.error(error));
  }

  static async getTimeUsageReports(from, to, ignoreCache) {
    try {
      const response = await wasteManagementClient.get(
        `${wasteManagementUrls.reports}/time-usage-report`,
        {
          params: {
            from,
            to,
          },
          cache: { ignoreCache },
        },
      );
      if (response?.status === 200 && response.data) {
        return response.data;
      } else {
        return [];
      }
    } catch (err) {
      console.error(err);
      throw new Error(err);
    }
  }
}
